<template>
  <span class="learning-progress-circle" :class="{ 'learning-progress-top' : isTop }">
    <svg class="progress-circle" :class="{ 'progress-top' : isTop }" viewBox="-50,-50,100,100">

      <!-- Survival Gradient -->
      <defs>
        <linearGradient id="linearColors" x1="1" y1="0" x2="0" y2="1">
          <stop offset="1%" stop-color="#FF9900"></stop>
          <stop offset="100%" stop-color="#FF0000"></stop>
        </linearGradient>
      </defs>

      <circle class="progress-circle-back" :r="radiuscircle" :class="completed ? classProgress : ''"/>
      <path class="progress-circle-front" :class="classProgress" :d="path"/>
      <text class="progress-text progress-section font-jp" alignment-baseline="middle" text-anchor="middle">{{ section.title }}</text>
      <text class="progress-text progress-percentage" alignment-baseline="middle" text-anchor="middle">{{percentage}}%</text>
    </svg>
  </span>
</template>

<script>
  export default {
    name: "ProgressBar",
    props: {
      section: {
        type: Object,
        required: true
      },
      progress: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        radiuscircle: 50,
        radius: 43,
        min: 0,
        max: 100
      }
    },
    computed: {
      isTop: function() {
        if (this.$route.name == 'lesson') {
          return true;
        }
        return false;
      },
      theta() {
        const frac = (this.progress - this.min) / (this.max - this.min) || 0; // This is the real code
        // const frac = .75; // This is a test .75 = 75%
        return frac * 2 * Math.PI;
      },
      path() {
        const large = this.theta > Math.PI;
        return `M0,-${this.radius} A${this.radius},${this.radius},0,${large ? 1 : 0},1,${this.endX},${this.endY}`;
      },
      endX() {
        return Math.cos(this.theta - Math.PI * 0.5) * this.radius;
      },
      endY() {
        return Math.sin(this.theta - Math.PI * 0.5) * this.radius;
      },
      // classProgress() {
      //   return 'progress-circle-survival'; // This need be changing depending on the section colors
      // },
      classProgress() {
        if (this.theta > (Math.PI * .1) ) {
          return 'progress-circle-survival'; // This need be changing depending on the section colors
        }
        return 'progress-circle-survival-early'; // This need be changing depending on the section colors
      },
      completed() {
        if (this.progress == this.max) {
          return true;
        }
        return false;
      },
      percentage() {
        return Math. round(this.progress); // This  is the real code
        // return 75; // This is a test 75%
      }
    },
  }
</script>